import { Box } from "@mui/material";

import { usePrivateLayoutContext } from "../../layouts";
import { BoltPlayer } from "../../components";
import { useDiscoverPageContext } from "./DiscoverPageContext";

import "./styles.css";

export const Background = () => {
  const { navbar__height, leftMenubar__width } = usePrivateLayoutContext();

  const { selectedItem } = useDiscoverPageContext();

  return (
    <Box
      sx={{
        position: "fixed",
        top: navbar__height,
        left: { xs: 0, md: leftMenubar__width },
        right: 0,
        bottom: 0,
      }}
    >
      <BoltPlayer url={selectedItem.video} controls={false} className="player-bg-mode" />
    </Box>
  );
};
